// Client-side CPF/CNPJ validators + formatters (mirror of backend algorithm)
const onlyDigits = (s) => (s || "").replace(/\D/g, "");

export function validateCPF(raw) {
  const c = onlyDigits(raw);
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  for (const j of [9, 10]) {
    let s = 0;
    for (let i = 0; i < j; i++) s += parseInt(c[i], 10) * (j + 1 - i);
    let d = (s * 10) % 11;
    if (d === 10) d = 0;
    if (d !== parseInt(c[j], 10)) return false;
  }
  return true;
}

export function validateCNPJ(raw) {
  const c = onlyDigits(raw);
  if (c.length !== 14 || /^(\d)\1+$/.test(c)) return false;
  const w12 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const w13 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (const [len, w] of [[12, w12], [13, w13]]) {
    let s = 0;
    for (let i = 0; i < len; i++) s += parseInt(c[i], 10) * w[i];
    let d = s % 11;
    d = d < 2 ? 0 : 11 - d;
    if (d !== parseInt(c[len], 10)) return false;
  }
  return true;
}

export function formatCPF(raw) {
  const c = onlyDigits(raw).slice(0, 11);
  return c
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
}

export function formatCNPJ(raw) {
  const c = onlyDigits(raw).slice(0, 14);
  return c
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function validateDoc(docType, raw) {
  if (!raw) return true; // optional
  return docType === "cpf" ? validateCPF(raw) : validateCNPJ(raw);
}

export function formatDoc(docType, raw) {
  return docType === "cpf" ? formatCPF(raw) : formatCNPJ(raw);
}
